import React      from 'react';
import classnames from 'classnames';
import Tooltip    from './Tooltip';
import Label      from './Label';
import TextInput  from './TextInput';

const Component = props => (
  <div className={classnames(props.wrapClass, props.className)}>
    <Label label={props.label} required={props.required} > <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} /> </Label>
    <TextInput {...props} />
    {props.children}
  </div>
);

Component.defaultProps = {
  label   : 'Text Component',
  required: false,
  wrapClass: 'form-group',
};

export default Component;
